import * as types from  '../actions'; 

const initialState = {
  allLogItems: [],
  status:0,
  activity:''  
};

export default function(state = initialState, action) {
    const response = action.response; 
    let timeVar = '~~'+Date.now()+Math.floor((Math.random() * 100) + 1); 
    
    switch(action.type) { 
        case types.ACTIVITY_LOG_LIST_SUCCESS:
            let totalPage = 0; 
            if(response.data.page_size && response.data.count) totalPage = Math.ceil(response.data.count/response.data.page_size);
            if(response.status===200){ 
                return {
                    ...state,
                    logData: response.data,
                    status: response.status,
                    activity: types.ACTIVITY_LOG_LIST_SUCCESS+timeVar,
                    totalPage: totalPage,
                    numRows: (response.data.results) ? response.data.results.length : response.data.length, 
                    count: (response.data.count) ? response.data.count : 0,     
                };
            }
            else {
                return {
                    ...state, 
                    status: response.status,
                    activity: types.ACTIVITY_LOG_LIST_ERROR+timeVar, 
                    response 
                };   
            }    
        // case types.ACTIVITY_LOG_LIST_ERROR: 
        //     return {
        //         ...state, 
        //         // status: response.status,
        //         activity: types.ACTIVITY_LOG_LIST_ERROR+timeVar, 
        //         response 
        //     };  
 
        case types.CLEAR:
            return {
                ...state, 
                activity:'',
                status:0               
            }  


        default:
            return state;
  }
};
